const DOT_HIT_RADIUS = 12;
const DOT_RADIUS = 5;
const DOT_SELECTED_RADIUS = 7;

interface ChartDotPayload {
  id: string;
}

export interface InteractiveChartDotProps {
  cx?: number;
  cy?: number;
  payload?: ChartDotPayload;
  hoveredDate: string | null;
  selectedDate: string;
  onSelectDate: (date: string) => void;
  fill: string;
  selectedFill: string;
  interactive?: boolean;
}

export const InteractiveChartDot = ({
  cx,
  cy,
  payload,
  hoveredDate,
  selectedDate,
  onSelectDate,
  fill,
  selectedFill,
  interactive = true,
}: InteractiveChartDotProps) => {
  if (cx == null || cy == null || !payload) {
    return <g />;
  }

  const isSelected = payload.id === selectedDate;
  const isHovered = payload.id === hoveredDate;
  const showDot = isSelected || isHovered;

  return (
    <g
      style={interactive ? { cursor: "pointer" } : undefined}
      onClick={interactive ? () => onSelectDate(payload.id) : undefined}
    >
      {interactive && (
        <circle cx={cx} cy={cy} r={DOT_HIT_RADIUS} fill="transparent" />
      )}
      {showDot && (
        <circle
          cx={cx}
          cy={cy}
          r={isSelected ? DOT_SELECTED_RADIUS : DOT_RADIUS}
          fill={isSelected ? selectedFill : fill}
          stroke={isSelected ? fill : "none"}
          strokeWidth={2}
        />
      )}
    </g>
  );
};
